import styled from 'styled-components';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { TranslateFunction, useTranslate } from '@dreryk/react-common';
import {
   appendTestableElementAttributes,
   basicBodyTextStyle,
   basicSmallTextStyle,
   fonts,
} from '@dreryk/react-components';

import { getPatientReferenceIdentifierTranslatableText } from '~libs.shared.patient';

import { patientTranslationKeys } from '../../../translations';

type ExistingPatientFormPatientSearchItemProps = {
   readonly patient: PatientSimple;
};

const getName = (patient: PatientSimple): string => {
   return `${patient.lastName ?? ''} ${patient.firstName ?? ''}`.trim();
};

const getDetails = (patient: PatientSimple, translate: TranslateFunction): string => {
   let result = '';

   if (patient.referenceIdentifier) {
      result += translate(getPatientReferenceIdentifierTranslatableText(patient.referenceIdentifier));
   }

   if (result && patient.phoneNumber) {
      result += ', ';
   }

   if (patient.phoneNumber) {
      result += `${translate(
         patientTranslationKeys.unconfirmed.patientSearchItem.phoneAbbreviation
      )} ${patient.phoneNumber.asString()}`;
   }
   return result;
};

const PatientName = styled.div`
   ${basicBodyTextStyle};
   font-weight: ${fonts.fontWeightBold};
`;

const PatientDetails = styled.div`
   ${basicSmallTextStyle};
   color: ${(props) => props.theme.border};
`;

export const ExistingPatientFormPatientSearchItem = (props: ExistingPatientFormPatientSearchItemProps): JSX.Element => {
   const translate = useTranslate();
   const { patient } = props;

   return (
      <div {...appendTestableElementAttributes(String(patient.id))}>
         <PatientName {...appendTestableElementAttributes('name')}>{getName(patient)}</PatientName>
         <PatientDetails {...appendTestableElementAttributes('details')}>
            {getDetails(patient, translate)}
         </PatientDetails>
      </div>
   );
};
